import React, { useState, useEffect } from 'react';

const AdminOrders = () => {
  // Todos hooks no topo
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [editingSongStatus, setEditingSongStatus] = useState(null);

  const SENHA = '1234'; // Mude aqui!

  useEffect(() => {
    if (isAuthenticated) fetchOrders();
  }, [isAuthenticated]);

  const fetchOrders = async () => {
    try {
        // ✅ Cache buster: ?t= timestamp
        const timestamp = Date.now();
        const response = await fetch(`/api/get_orders.php?t=${timestamp}`);
        const data = await response.json();
        console.log('📊 Pedidos carregados:', data.orders?.length); // Debug
        setOrders(data.orders || []);
    } catch (error) {
        console.error('Erro:', error);
    } finally {
        setLoading(false);
    }
  };

  const checkPassword = () => {
    if (password === SENHA) {
      setIsAuthenticated(true);
    } else {
      alert('Senha incorreta!');
      setPassword('');
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{padding: '5rem 2rem', textAlign: 'center', background: '#f8fafc', minHeight: '100vh'}}>
        <style>{`.login-input{width:100%;padding:1rem;font-size:1.2rem;border-radius:.5rem;border:2px solid #e2e8f0;margin:1rem 0;box-sizing:border-box}.login-btn{width:100%;padding:1rem;background:#8B5CF6;color:white;border:none;border-radius:.5rem;font-size:1.1rem;cursor:pointer}`}</style>
        <div>
          <h1 style={{color:'#64748b'}}>🔐 Painel Admin</h1>
          <input type="password" className="login-input" value={password} onChange={(e)=>setPassword(e.target.value)} onKeyPress={(e)=>e.key==='Enter'&&checkPassword()} placeholder="Senha..."/>
          <button className="login-btn" onClick={checkPassword}>Entrar</button>
        </div>
      </div>
    );
  }

  const filteredOrders = orders.filter(order => filterStatus === 'all' || order.payment_status === filterStatus);

  // Calcular tempo restante
  const getTimeRemaining = (deliveryTime, createdAt) => {
    const now = new Date();
    const created = new Date(createdAt + 'Z'); // 👈 força UTC

    const deliveryHours = parseInt(deliveryTime.replace('h',''), 10);
    const deadline = new Date(
        created.getTime() + deliveryHours * 60 * 60 * 1000
    );

    const diff = deadline - now;

    if (diff <= 0) return '⏰ ATRASADO!';

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}h ${minutes}m`;
  };

  const copyOrderInfo = (order) => {
    const info = `🎵═══ PEDIDO #${order.id} ═══🎵

    📋 DADOS DO CLIENTE
    👤 Nome: ${order.customer_name || 'N/A'}
    📧 Email: ${order.customer_email || 'N/A'}
    📱 Telefone: ${order.customer_phone || 'N/A'}

    🎯 DESTINATÁRIO
    📂 Tipo: ${order.type_group === 'pessoa' ? 'Pessoa' : order.type_group === 'evento' ? 'Evento' : 'N/A'}
    👥 Relacionamento: ${order.recipient_display || 'N/A'}
    🎯 Nome alvo: ${order.target_name || 'N/A'}

    📅 EVENTO
    📋 Evento: ${order.event_display || 'N/A'}

    🎶 ESTILO MUSICAL
    🎵 Estilo: ${order.style_display || 'N/A'}
    🗣️ Voz: ${order.voice_preference || 'N/A'}
    🔄 Revisões: ${order.revisions || 1}
    ⏰ Prazo entrega: ${order.delivery_time || 'N/A'}

    📝 CONTEÚDO
    ✨ Qualidades: ${order.qualities || 'Não informado'}
    💭 Memórias: ${order.memories || 'Não informado'}

    💰 FINANCEIRO
    💵 Valor total: R$ ${parseFloat(order.total_amount || 0).toFixed(2).replace('.', ',')}
    💳 Status pagamento: ${order.payment_status || 'N/A'}
    🆔 ID pagamento: ${order.payment_id || 'N/A'}
    🔗 Ref externa: ${order.external_reference || 'N/A'}

    📊 STATUS ATUAL
    🎵 Status música: ${order.song_status || 'em_andamento'}
    📅 Data criação: ${new Date(order.created_at).toLocaleString('pt-BR')}

    ═══════════════════════════════`;

        navigator.clipboard.writeText(info);
        alert(`✅ Copiado! Pedido #${order.id} - ${order.customer_name}`);
  };


  // Marcar música pronta
  const toggleSongStatus = async (orderId, newStatus) => {
    try {
        await fetch('/api/update_song_status.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({order_id: orderId, song_status: newStatus})
        });
        
        // ✅ REFRESH IMEDIATO com cache buster
        const ts = Date.now();
        const response = await fetch(`/api/get_orders.php?t=${ts}`);
        const data = await response.json();
        setOrders(data.orders || []);
        
    } catch (error) {
        alert('Erro!');
    }
  };


  // Excluir pedido
  const deleteOrder = async (orderId) => {
    if (!window.confirm('🗑️ Excluir pedido #' + orderId + '?')) return;
    try {
      await fetch(`/api/delete_order.php`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({order_id: orderId})
      });
      fetchOrders();
    } catch (error) {
      alert('Erro ao excluir!');
    }
  };

  return (
    <div className="admin-dashboard">
      <style>{`
        :root{--primary:#8B5CF6;--success:#10b981;--warning:#f59e0b;--danger:#ef4444;--gray:#6b7280}
        .admin-dashboard{max-width:1400px;margin:0 auto;padding:2rem;font-family:'Segoe UI',sans-serif;background:#f8fafc;min-height:100vh}
        .header{background:linear-gradient(135deg,var(--primary),#764ba2);color:white;padding:2rem;border-radius:1rem;margin-bottom:2rem;text-align:center}
        .stats-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:1rem;margin-bottom:2rem}
        .stat-card{background:white;padding:1.5rem;border-radius:1rem;text-align:center;box-shadow:0 4px 15px rgba(0,0,0,.1)}
        .stat-number{font-size:2rem;font-weight:700}
        .controls{display:flex;gap:1rem;margin-bottom:2rem;flex-wrap:wrap;align-items:center}
        .filter-select{padding:.75rem 1rem;border:2px solid #e2e8f0;border-radius:.5rem;font-size:1rem}
        .btn{padding:.75rem 1.5rem;border:none;border-radius:.5rem;cursor:pointer;font-weight:600;font-size:.95rem;transition:all .3s}
        .btn-refresh{background:var(--success);color:white}
        .btn-copy{background:var(--primary);color:white}
        .btn-song{background:#06b6d4;color:white}
        .btn-song.active{background:var(--success);color:white}
        .btn-delete{background:var(--danger);color:white}
        .orders-table{background:white;border-radius:1rem;overflow:hidden;box-shadow:0 10px 25px rgba(0,0,0,.1)}
        table{width:100%;border-collapse:collapse}
        th,td{padding:1rem .75rem;border-bottom:1px solid #e2e8f0}
        th{background:#f8fafc;font-weight:600;color:#475569;font-size:.9rem}
        .status-badge{padding:.4rem 1rem;border-radius:2rem;font-weight:600;font-size:.8rem;color:white}
        .phone-link{color:var(--primary);text-decoration:none;font-weight:600}
        .logout-btn{position:absolute;top:2rem;right:2rem;background:var(--danger);color:white;border:none;padding:.75rem 1.5rem;border-radius:.5rem;cursor:pointer}
        .time-remaining{font-weight:600;color:var(--warning)}
        .song-ready{font-size:1.2rem;cursor:pointer}
        @media(max-width:768px){.admin-dashboard{padding:1rem}.controls{flex-direction:column}}
       
        select:hover {
            border-color: #8B5CF6;
            box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
            transform: scale(1.02);
        }
        select:focus {
            outline: none;
            border-color: #8B5CF6;
            box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.2);
        }

      
      `}</style>

      <button className="logout-btn" onClick={() => setIsAuthenticated(false)}>🚪 Sair</button>

      <div className="header">
        <h1>📋 Painel de Pedidos</h1>
        <p>{orders.length} pedidos | {orders.filter(o => o.payment_status === 'approved').length} aprovados</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-number" style={{color:'#10b981'}}>{orders.filter(o=>o.payment_status==='approved').length}</div>
          <div>Aprovados</div>
        </div>
        <div className="stat-card">
          <div className="stat-number" style={{color:'#f59e0b'}}>{orders.filter(o=>o.payment_status==='pending').length}</div>
          <div>Pendentes</div>
        </div>
        <div className="stat-card">
          <div className="stat-number" style={{color:'#ef4444'}}>{orders.filter(o=>['rejected','cancelled'].includes(o.payment_status)).length}</div>
          <div>Rejeitados</div>
        </div>
      </div>

      <div className="controls">
        <select className="filter-select" value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}>
          <option value="all">Todos</option>
          <option value="approved">Aprovados</option>
          <option value="pending">Pendentes</option>
        </select>
        <button className="btn btn-refresh" onClick={fetchOrders}>🔄 Atualizar</button>
      </div>

      <div className="orders-table">
        {loading ? (
          <div style={{padding:'3rem',textAlign:'center',color:'#64748b'}}>⏳ Carregando...</div>
        ) : filteredOrders.length === 0 ? (
          <div style={{padding:'3rem',textAlign:'center',color:'#64748b'}}>📭 Nenhum pedido</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th><th>Cliente</th><th>Para</th><th>Tel</th><th>Estilo</th>
                <th>⏰ Tempo</th><th>R$</th><th>Status</th><th>Música</th><th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(order => {
                const timeLeft = getTimeRemaining(order.delivery_time, order.created_at);
                const isSongReady = order.song_ready == 1;
                return (
                  <tr key={order.id} style={{backgroundColor: isSongReady ? '#f0fdf4' : ''}}>
                    <td><strong>#{order.id}</strong></td>
                    <td>{order.customer_name}</td>
                    <td><strong>{order.target_name}</strong></td>
                    <td><a href={`https://wa.me/55${order.customer_phone?.replace(/\D/g,'')}`} target="_blank" className="phone-link">📱</a></td>
                    <td>{order.style_group}</td>
                    <td><span className={timeLeft.includes('ATRASADO') ? 'time-remaining' : ''}>{timeLeft}</span></td>
                    <td>R$ {parseFloat(order.total_amount).toFixed(2).replace('.', ',')}</td>
                    <td>
                      <span className="status-badge" style={{backgroundColor: {
                        pending:'#f59e0b',approved:'#10b981',rejected:'#ef4444',cancelled:'#6b7280'
                      }[order.payment_status] || '#6b7280'}}>
                        {order.payment_status === 'approved' ? '✅ OK' : order.payment_status}
                      </span>
                    </td>
                    <td style={{position: 'relative'}}>
                        <select 
                            value={order.song_status || 'em_andamento'}
                            onChange={(e) => toggleSongStatus(order.id, e.target.value)}
                            style={{
                            width: '140px', padding: '.5rem .75rem', borderRadius: '.5rem', 
                            border: '2px solid #e2e8f0', fontSize: '.9rem', fontWeight: '600',
                            background: order.song_status === 'pronta' ? '#dcfce7' : '#fef3c7',
                            color: order.song_status === 'pronta' ? '#166534' : '#92400e',
                            cursor: 'pointer'
                            }}
                            title="Status da música"
                        >
                            <option value="em_andamento">⏳ Em andamento</option>
                            <option value="pronta">✅ Pronta</option>
                        </select>
                    </td>
                    <td>
                      <button className="btn btn-copy" onClick={()=>copyOrderInfo(order)}>📋 Copiar</button>
                      <button className="btn btn-delete" onClick={()=>deleteOrder(order.id)}>🗑️ Excluir</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminOrders;
